import { Injectable, Signal, WritableSignal, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private readonly _mobileOpen: WritableSignal<boolean> = signal(false);

  public get mobileOpen(): Signal<boolean> {
    return this._mobileOpen;
  }

  public set mobileOpen(value: boolean) {
    this._mobileOpen.set(value);
  }

  public toggle(): void {
    this._mobileOpen.update(v => !v);
  }
}
